import { HttpHeaders } from "@angular/common/http";

export const HEADERS = { 'x-intercept-error': "true" }